package com.yogaaicoach.pages.dashboard

import com.yogaaicoach.common.ui.components.*
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import web.cssom.ClassName

internal external interface NoActiveProgramPageProps : Props {
    var dashboardData: DashboardData
    var onAddNewTraining: () -> Unit
    var onNavigateToTest: () -> Unit
}

// Pixel-matched against NoActiveProgramDashboardScreen.kt: SummaryComponent (reused from
// ProgramDashboardPage.kt) + the same shared HeroCard.kt this screen and OnboardingPage.kt both
// use, just with different title/subtitle/button text and a bold badge instead of "New Member".
internal val NoActiveProgramPage = FC<NoActiveProgramPageProps> { props ->
    div {
        className = ClassName("no-active-program-page")

        FreeTrialBannerIfNeeded()
        TestButtonIfTestEnv(props.onNavigateToTest)

        SummarySection(props.dashboardData)

        div {
            className = ClassName("hero-card")

            div {
                className = ClassName("hero-badge-row")
                AutoAwesomeIcon {}
                span { className = ClassName("hero-badge-row-bold"); +"Great Progress — Yoga Program Finished." }
            }

            h2 { className = ClassName("hero-title"); +"Ready to Start Again?" }

            button {
                className = ClassName("hero-cta-button")
                onClick = { props.onAddNewTraining() }
                span { +"Create New Program" }
                AutoAwesomeIconWhite {}
            }

            p {
                className = ClassName("hero-subtitle")
                +"Create your personalized yoga program tailored to your goals, schedule, and experience level."
            }

            HighlightsSection()
        }
    }
}
